import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PanoramicService } from '../../services/panoramic.service';
// import { ModalComponent } from '../../../home/components/modal/modal.component';
// import { ModalRemoveComponent } from '../../../home/components/modal-remove-active/modal-remove.component';
import { MapService } from "../../services/map.service";
import { environment } from 'src/environments/environment';

declare function embedpano(params): any;

@Component({
  selector: 'app-view-panoramic',
  templateUrl: './panoramic-view.component.html',
  styleUrls: ['./panoramic-view.component.css']
})
export class PanoramicViewComponent implements OnInit, OnDestroy {

  loaded: boolean;
   
  constructor(
    protected panoramicService: PanoramicService, 
    protected dialog: MatDialog, 
    protected mapService: MapService,
    ) {}

  ngOnInit() {
    if (!document.getElementById("krpanoSWFObject")) {
      embedpano({
        swf: './assets/panoramic/tour.swf', xml: './assets/panoramic/tour.xml ',
        target: 'pano', html5: 'only', mobilescale: 1.0, passQueryParameters: true,
        onready: this.panoramicReady, panoramicService: this.panoramicService, mapService: this.mapService, dialog: this.dialog
      });
    };
  }

  panoramicReady(panoramic) {
    this.mapService.getViewMap().rotation = 0;
    this.mapService.getViewMap().constraints.rotationEnabled = false;
    this.panoramicService.setPanoramic(panoramic);
    this.mapService.addMarkersLayer(panoramic);
     // This variable contains the date of the virtual tour, this is passed to krpano using "set", and is shown in vtourskin.xml --DS
    panoramic.set("myKrpVar",environment.imagesDate);

    //this calls the last scene when the view is closed an re-opened --DS
    if (this.mapService.currentScene){
      let xml = this.mapService.currentScene.split('_')[1] + '.xml'
      this.panoramicService.loadScene(xml, this.mapService.currentScene)
    }       
  }

  ngOnDestroy() {
    this.mapService.getViewMap().constraints.rotationEnabled = true;
  }
}

 // panoramic.set('events.onclick', function () {
      
    //   if (this.panoramicService.getCreateActive()) {
    //     this.panoramicService.addActive(this.dialog, ModalComponent, ModalRemoveComponent);
    //     this.panoramicService.setCreateActive(false);
    //   }
    // }.bind(this));

    // panoramic.set('events.onloadcomplete', function () {

    //   if (!this.loaded) {
    //     this.loaded = true;
    //   }
    // }.bind(this));

    // panoramic.set('events.onxmlcomplete', function () {
    //   this.panoramicService.addPoints(this.dialog, ModalRemoveComponent);
    //   if (!this.loaded) {
    //     this.loaded = true;
    //   }
    // }.bind(this));